(() => {
  const relevantEvents = ['load', 'ajaxComplete', 'cart:updated', 'cart:refresh'];
  const pendingRoots = new Set();
  let scheduled = false;
  let fullScanRequested = false;

  function forEachMatch(scope, selector, callback) {
    const root = scope || document;
    if (root.nodeType === 1 && root.matches(selector)) {
      callback(root);
    }
    root.querySelectorAll(selector).forEach(callback);
  }

  function removeDiscountedPriceLabel(scope) {
    forEachMatch(scope, '.bndlr-money, .bndlr-new-price, [aria-label="Discounted price"]', (element) => {
      const ariaLabel = element.getAttribute('aria-label');
      if (ariaLabel === 'Discounted price') {
        element.setAttribute('aria-label', 'Preis');
      } else if (ariaLabel && ariaLabel.includes('Discounted price')) {
        element.setAttribute('aria-label', ariaLabel.replace(/Discounted price/g, 'Preis').trim());
      }

      if (element.textContent && element.textContent.includes('Discounted price')) {
        element.textContent = element.textContent.replace(/Discounted price\s*/g, '');
      }
    });
  }

  function normalizeBundleStatusLabels(scope) {
    forEachMatch(scope, '.cart-form-item__price-title-variants span.text-size--xsmall, .cart-item__content span.text-size--xsmall', (span) => {
      const text = span.textContent ? span.textContent.trim() : '';
      if (text.startsWith('Rabatt') || text === 'Bundle-Preis aktiv') {
        if (text !== 'Bundle-Preis aktiv') {
          span.textContent = 'Bundle-Preis aktiv';
        }
        span.style.fontWeight = '500';
        span.style.color = 'green';
        span.setAttribute('data-bundle-price', 'true');
      }
    });
  }

  function removeAllStrikethroughPrices(scope) {
    forEachMatch(scope, 'del', (del) => {
      del.style.display = 'none';
    });

    forEachMatch(scope, 'span.visually-hidden', (span) => {
      if (span.textContent.trim() === 'Sale-Preis') {
        span.style.display = 'none';
      }
    });

    forEachMatch(scope, '.cart-item__content span.text-size--xsmall, .cart-form-item__price-title-variants span.text-size--xsmall', (span) => {
      if (!span.hasAttribute('data-bundle-price') && span.textContent && span.textContent.includes('Rabatt')) {
        span.style.display = 'none';
      }
    });

    forEachMatch(scope, '.cart-item__price span, .cart-form-item__price span', (span) => {
      if (span.querySelector('del')) {
        span.style.display = 'none';
      }
    });

    forEachMatch(scope, '.product-price--compare', (element) => {
      element.style.display = 'none';
    });

    forEachMatch(scope, '[class*="compare-price"], [class*="was-price"], [class*="original-price"]', (element) => {
      element.style.display = 'none';
    });

    forEachMatch(scope, '.product-item__text del, .product-price del', (del) => {
      del.style.display = 'none';
    });
  }

  function normalizePricesIn(scope) {
    normalizeBundleStatusLabels(scope);
    removeAllStrikethroughPrices(scope);
    removeDiscountedPriceLabel(scope);
  }

  function applyScheduledPriceNormalizations() {
    scheduled = false;
    const roots = fullScanRequested ? [document] : Array.from(pendingRoots);
    fullScanRequested = false;
    pendingRoots.clear();
    roots.forEach((root) => {
      if (root === document || root.isConnected) {
        normalizePricesIn(root);
      }
    });
  }

  function queueMutationRoot(root) {
    if (!root || root.nodeType !== 1 || fullScanRequested) {
      return;
    }
    for (const pendingRoot of pendingRoots) {
      if (pendingRoot === root || pendingRoot.contains(root)) {
        return;
      }
      if (root.contains(pendingRoot)) {
        pendingRoots.delete(pendingRoot);
      }
    }
    pendingRoots.add(root);
  }

  function schedulePriceNormalization(root = document) {
    if (root === document) {
      fullScanRequested = true;
      pendingRoots.clear();
    } else {
      queueMutationRoot(root);
    }
    if (scheduled) {
      return;
    }
    scheduled = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(applyScheduledPriceNormalizations);
    } else {
      window.setTimeout(applyScheduledPriceNormalizations, 16);
    }
  }

  schedulePriceNormalization(document);

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.nodeType === 1 && mutation.target !== document.body && mutation.target !== document.documentElement) {
          queueMutationRoot(mutation.target);
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            queueMutationRoot(node);
          } else if (node.nodeType === 3 && mutation.target.nodeType === 1) {
            queueMutationRoot(mutation.target);
          }
        });
      });
      if (pendingRoots.size > 0) {
        schedulePriceNormalization(Array.from(pendingRoots)[0]);
      }
    });
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  relevantEvents.forEach((eventName) => {
    document.addEventListener(eventName, () => schedulePriceNormalization(document));
  });

  if (window.Shopify && window.Shopify.onCartUpdate) {
    window.Shopify.onCartUpdate = ((originalFunction) => {
      return function wrappedOnCartUpdate() {
        if (originalFunction) {
          originalFunction.apply(this, arguments);
        }
        schedulePriceNormalization(document);
      };
    })(window.Shopify.onCartUpdate);
  }
})();
